

export const soraFAQ = {
    title: 'Sora 2 常見問題',
    sub: '深入了解使用 Sora 2 生成專業影片的方方面面：功能與能力、最佳實務與操作建議。',
    items: [
      { num: '01', q: '什麼是 Sora 2？與其他影片生成器有何差異？', a: 'Sora 2 是 OpenAI 最新的 AI 影片生成模型，在世界模擬與物理一致性上有突破性表現。可從文字提示或參考圖片生成具電影質感的影片。' },
      { num: '02', q: 'Sora 2 的關鍵功能有哪些？', a: '雙模式生成（文字轉影片、圖片轉影片）、進階物理模擬、彈性長寬比、最高 15 秒的高清輸出，以及對場景與風格的精準創作控制。' },
      { num: '03', q: '生成影片需要多少時間？', a: '依設定而異。標準 10 秒高清影片一般需 3–5 分鐘；15 秒高清更久。輸出包含原生音訊。' },
      { num: '04', q: '為何我的生成經常失敗？', a: '多因內容政策違規。請避免不允許內容，並使用清晰、具描述性的提示詞以提高成功率。' },
      { num: '05', q: 'Sora 2 如何處理影片中的物理與真實感？', a: 'Sora 2 在物理準確性與真實感上表現優異，能處理浮力、重力與表面動態，維持運動一致性。' },
      { num: '06', q: '可否用於社群與商業內容？', a: '可以。Sora 2 非常適合社群與商業專案。輸出無浮水印，並為 TikTok、Instagram、YouTube 等平台優化。' },
      { num: '07', q: '與早期模型相比，Sora 2 的提示遵從度如何？', a: '多鏡頭情境下仍能保持視覺與敘事一致性，提示遵從度更佳。提升的可控性便於達成精準的創作效果。' },
      { num: '08', q: '費用如何？積分系統怎麼運作？', a: '採透明的積分制按次計費。依需求購買即可，無需訂閱。' }
    ],
    cta: '還有關於 Sora 2 的問題？',
    contact: '聯絡支援團隊'
  };
